// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DataDensity__wrapper--2Ou1Z","iconButton":"DataDensity__iconButton--10sdG","dim":"DataDensity__dim--3P2Vq"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/DataDensity/DataDensity.css
// module id = U5Hf
// module chunks = 47